/* global Config */

// Vendor Components
import React from 'react';
import {Link} from 'react-router-dom';

// Components
import MainNav from './main-nav';
import LoggedInDropdown from '../../components-app/logged-in-dropdown';

// Images
import logo from './dishLogo.svg';

// Styles
import './main-header.scss';

const styles = {
    header: {background: 'black'},
    icon: {marginBottom: 12, marginLeft: 13, width: 60},
};

const MainHeader = () => (
    <header className="main-header" style={styles.header}>
        <Link className="main-header--link" to="/sub-shelves/homeShelf">
            <img
                alt="Dynamic Shelves"
                className="main-header--logo"
                src={logo}
                style={styles.icon}
                title="Dynamic Shelves"
            />
        </Link>
        {/*<LoggedInDropdown className="main-header--logged-in" />*/}
        <MainNav className="main-header--main-nav" />
    </header>
);

export default MainHeader;
